import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [adminUser, setAdminUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadCustomer = async () => {
    const t = localStorage.getItem("rieave.customer.token");
    if (!t) { setCustomer(null); return; }
    try {
      const { data } = await api.get("/auth/customer/me");
      setCustomer(data);
    } catch {
      localStorage.removeItem("rieave.customer.token");
      setCustomer(null);
    }
  };

  const loadAdmin = async () => {
    const t = localStorage.getItem("rieave.admin.token");
    if (!t) { setAdminUser(null); return; }
    try {
      const { data } = await api.get("/auth/admin/me");
      setAdminUser(data);
    } catch {
      localStorage.removeItem("rieave.admin.token");
      setAdminUser(null);
    }
  };

  useEffect(() => {
    (async () => {
      await Promise.all([loadCustomer(), loadAdmin()]);
      setLoading(false);
    })();
  }, []);

  const customerLogout = () => {
    localStorage.removeItem("rieave.customer.token");
    setCustomer(null);
  };

  const adminLogout = () => {
    localStorage.removeItem("rieave.admin.token");
    setAdminUser(null);
  };

  const setCustomerToken = (token, user) => {
    localStorage.setItem("rieave.customer.token", token);
    setCustomer(user);
  };

  const setAdminToken = (token, user) => {
    localStorage.setItem("rieave.admin.token", token);
    setAdminUser(user);
  };

  return (
    <AuthContext.Provider
      value={{
        customer, adminUser, loading,
        setCustomerToken, setAdminToken,
        customerLogout, adminLogout,
        refreshCustomer: loadCustomer, refreshAdmin: loadAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
